@import "../../global/gx-ide-common.scss";
@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  height: 100%;
}

.dialog-header {
  margin-block-end: 16px;
}

.main-content {
  grid-auto-rows: max-content;
}

.footer-info {
  margin-bottom: 12px;
}

.description {
  display: grid;
  grid-auto-rows: max-content;
  gap: var(--spacing-gap-m);
}
